"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMY = function FlagMY(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-102.83H-193v-12.11a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "20.16",
    width: "409.6",
    height: "19.17",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "39.34",
    width: "409.6",
    height: "19.17",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "58.5",
    width: "409.6",
    height: "19.17",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "77.68",
    width: "409.6",
    height: "19.17",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "96.84",
    width: "409.6",
    height: "19.17",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "116.01",
    width: "409.6",
    height: "19.17",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "135.18",
    width: "409.6",
    height: "19.17",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,50.52H-193V19.24h7.06V31.35H216.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "173.51",
    width: "409.6",
    height: "19.17",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "192.68",
    width: "409.6",
    height: "19.17",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "211.86",
    width: "409.6",
    height: "19.17",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "231.02",
    width: "409.6",
    height: "19.17",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V127.19H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.17,31.35H-185.94A7.06,7.06,0,0,1-193,24.29V-114.94a7.06,7.06,0,0,1,7.06-7.06H54.17a7.06,7.06,0,0,1,7.06,7.06V24.29a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-125.91-45.4A48.39,48.39,0,0,1-77.55-93.78a48.27,48.27,0,0,1,18.92,3.85A.68.68,0,0,0-58-91.12a55.08,55.08,0,0,0-34-9.48,55.48,55.48,0,0,0-52.22,51.51A55.26,55.26,0,0,0-89,9.87a55.16,55.16,0,0,0,31-9.52A.68.68,0,0,0-58.7-.84,48.29,48.29,0,0,1-77.54,3,48.4,48.4,0,0,1-125.91-45.4",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-15.35-45.4,5.09-53.31a.94.94,0,0,0-.41-1.82l-21.84,1.75,15-16.05a.94.94,0,0,0-1.16-1.45l-19,11.07,6.55-20.94a.94.94,0,0,0-1.67-.81L-29.7-63.36l-3.15-21.72a.94.94,0,0,0-1.86,0l-2,13.74-.84,5.82-.32,2.16L-50.16-81.54a.94.94,0,0,0-1.68.8l6.57,20.93-19-11.07a.94.94,0,0,0-1.16,1.45l15,16.05-21.85-1.75a.94.94,0,0,0-.41,1.82l20.46,7.91-20.46,7.91a.94.94,0,0,0,.41,1.81l21.85-1.75-15,16.09a.94.94,0,0,0,1.16,1.45l19-11.1-6.57,20.92a.94.94,0,0,0,1.68.81l12.28-18.18.32,2.21.84,5.76,2,13.78a.94.94,0,0,0,1.86,0l3.15-21.75L-17.41-9.25a.94.94,0,0,0,1.67-.8L-22.29-31l19,11.1a.94.94,0,0,0,1.16-1.45l-15-16.09L4.68-35.68a.94.94,0,0,0,.42-1.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMY;
exports["default"] = _default;